"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrganizationItem = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var stringUtils = _interopRequireWildcard(require("./utils"));
var _ExternalTeamPill = _interopRequireDefault(require("../ExternalTeamPill"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable max-classes-per-file */
var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 8a5 5 0 1 1 10 0A5 5 0 0 1 7 8zm2.321 6.533A7.001 7.001 0 0 1 19 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467z"
  }));
};
UserIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var TeamIcon = function TeamIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0zM8.583 6.03a2.302 2.302 0 1 0 .016 4.566 1 1 0 1 1 .264 1.983 4.302 4.302 0 1 1-.03-8.533 1 1 0 1 1-.25 1.984zm3.738 8.503A7.001 7.001 0 0 1 22 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467zm-4.338.383a1 1 0 0 1-.88 1.107A3.5 3.5 0 0 0 4 19.5a1 1 0 1 1-2 0 5.5 5.5 0 0 1 4.876-5.464 1 1 0 0 1 1.107.88z"
  }));
};
TeamIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "item": "AutocompleteItem__item__2OfkQ",
  "item-container": "AutocompleteItem__item-container__284ve",
  "itemContainer": "AutocompleteItem__item-container__284ve",
  "item-icon": "AutocompleteItem__item-icon__3PH0J",
  "itemIcon": "AutocompleteItem__item-icon__3PH0J",
  "item-label": "AutocompleteItem__item-label__zKdEK",
  "itemLabel": "AutocompleteItem__item-label__zKdEK",
  "org-name-label": "AutocompleteItem__org-name-label__1YtHU",
  "orgNameLabel": "AutocompleteItem__org-name-label__1YtHU",
  "team-name": "AutocompleteItem__team-name__1ULp4",
  "teamName": "AutocompleteItem__team-name__1ULp4",
  "disabled-warning": "AutocompleteItem__disabled-warning__1SiM8",
  "disabledWarning": "AutocompleteItem__disabled-warning__1SiM8",
  "disabled-item": "AutocompleteItem__disabled-item__hfwQQ",
  "disabledItem": "AutocompleteItem__disabled-item__hfwQQ"
}; 
require('./AutocompleteItem.css');
var HighlightedText = function HighlightedText(_ref) {
  var text = _ref.text,
    search = _ref.search;
  var textParts = stringUtils.splitMatchingCharacters(text, search);
  return textParts.map(function (part, ix) {
    return part.toLowerCase() === search.toLowerCase() ? /*#__PURE__*/_react.default.createElement("strong", {
      key: "text-part-".concat(ix)
    }, part) : part;
  });
};
HighlightedText.propTypes = {
  text: _propTypes.default.string,
  search: _propTypes.default.string
};
var ItemPropTypes = {
  identity: _propTypes.default.object.isRequired
};
var AutocompleteItemTemplate = /*#__PURE__*/function (_React$PureComponent) {
  function AutocompleteItemTemplate() {
    (0, _classCallCheck2.default)(this, AutocompleteItemTemplate);
    return _callSuper(this, AutocompleteItemTemplate, arguments);
  }
  (0, _inherits2.default)(AutocompleteItemTemplate, _React$PureComponent);
  return (0, _createClass2.default)(AutocompleteItemTemplate, [{
    key: "renderIcon",
    value: function renderIcon() {
      return null;
    }
  }, {
    key: "renderItemLabel",
    value: function renderItemLabel() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var identity = this.props.identity;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.item
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "autocomplete-item",
        className: (0, _classnames2.default)(styles.itemContainer, (0, _defineProperty2.default)({}, styles.disabledItem, identity.isDisabled), 'fs-block')
      }, this.renderIcon(), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "item-label-autocomplete",
        className: styles.itemLabel
      }, this.renderItemLabel()), identity.isDisabled ? /*#__PURE__*/_react.default.createElement("em", {
        "data-test-id": "disabled-warning-autocomplete",
        className: styles.disabledWarning
      }, "Already shared") : null));
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(AutocompleteItemTemplate, "propTypes", ItemPropTypes);
var UserItem = /*#__PURE__*/function (_AutocompleteItemTemp) {
  function UserItem() {
    (0, _classCallCheck2.default)(this, UserItem);
    return _callSuper(this, UserItem, arguments);
  }
  (0, _inherits2.default)(UserItem, _AutocompleteItemTemp);
  return (0, _createClass2.default)(UserItem, [{
    key: "renderIcon",
    value: function renderIcon() {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        role: "presentation",
        "data-test-id": "user-icon-autocomplete",
        className: styles.itemIcon,
        size: 25
      }, /*#__PURE__*/_react.default.createElement(UserIcon, null));
    }
  }, {
    key: "renderItemLabel",
    value: function renderItemLabel() {
      var _this$props = this.props,
        label = _this$props.label,
        search = _this$props.search;
      return /*#__PURE__*/_react.default.createElement(HighlightedText, {
        text: label,
        search: search
      });
    }
  }]);
}(AutocompleteItemTemplate);
var TeamItem = /*#__PURE__*/function (_AutocompleteItemTemp2) {
  function TeamItem() {
    (0, _classCallCheck2.default)(this, TeamItem);
    return _callSuper(this, TeamItem, arguments);
  }
  (0, _inherits2.default)(TeamItem, _AutocompleteItemTemp2);
  return (0, _createClass2.default)(TeamItem, [{
    key: "renderIcon",
    value: function renderIcon() {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        role: "presentation",
        "data-test-id": "team-icon-autocomplete",
        className: styles.itemIcon,
        size: 25
      }, /*#__PURE__*/_react.default.createElement(TeamIcon, null));
    }
  }, {
    key: "renderItemLabel",
    value: function renderItemLabel() {
      var _this$props2 = this.props,
        identity = _this$props2.identity,
        search = _this$props2.search;
      var label = this.props.label;
      label = identity.numberOfMembers ? "".concat(label, " (").concat(identity.numberOfMembers, ")") : label;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.teamName
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(HighlightedText, {
        text: label,
        search: search
      }), ' '), identity.type === 'external' ? /*#__PURE__*/_react.default.createElement(_ExternalTeamPill.default, {
        hasBeenShared: identity.isDisabled
      }) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.orgNameLabel
      }, identity.organization.name));
    }
  }]);
}(AutocompleteItemTemplate);
var OrganizationItem = exports.OrganizationItem = /*#__PURE__*/function (_AutocompleteItemTemp3) {
  function OrganizationItem() {
    (0, _classCallCheck2.default)(this, OrganizationItem);
    return _callSuper(this, OrganizationItem, arguments);
  }
  (0, _inherits2.default)(OrganizationItem, _AutocompleteItemTemp3);
  return (0, _createClass2.default)(OrganizationItem, [{
    key: "renderIcon",
    value: function renderIcon() {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        role: "presentation",
        "data-test-id": "team-icon-autocomplete",
        className: styles.itemIcon,
        size: 25
      }, /*#__PURE__*/_react.default.createElement(TeamIcon, null));
    }
  }, {
    key: "renderItemLabel",
    value: function renderItemLabel() {
      var _this$props3 = this.props,
        identity = _this$props3.identity,
        search = _this$props3.search,
        isExternal = _this$props3.isExternal;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.teamName
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "organization-label"
      }, "Everyone at ", /*#__PURE__*/_react.default.createElement(HighlightedText, {
        text: identity.name,
        search: search
      })), isExternal ? /*#__PURE__*/_react.default.createElement(_ExternalTeamPill.default, {
        hasBeenShared: identity.isDisabled
      }) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.orgNameLabel
      }, identity.name, " (", identity.domain, ")"));
    }
  }]);
}(AutocompleteItemTemplate);
var AutocompleteItem = function AutocompleteItem(option) {
  var label = option.label,
    identity = option.identity,
    search = option.search;
  switch (identity.identityType) {
    case 'team':
      return /*#__PURE__*/_react.default.createElement(TeamItem, {
        label: label,
        identity: identity,
        search: search
      });
    case 'user':
      return /*#__PURE__*/_react.default.createElement(UserItem, {
        label: label,
        identity: identity,
        search: search
      });
    case 'externalOrganization':
      return /*#__PURE__*/_react.default.createElement(OrganizationItem, {
        label: label,
        identity: identity,
        search: search,
        isExternal: true
      });
    case 'organization':
      return /*#__PURE__*/_react.default.createElement(OrganizationItem, {
        label: label,
        identity: identity,
        search: search
      });
    default:
      return 'Unspecified identity';
  }
};
var _default = exports.default = AutocompleteItem;
//# sourceMappingURL=AutocompleteItem.js.map